import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
const API_URL = process.env.APP_API_URL ?? '';
const FRONTEND = {
    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'unknown',
    commit: typeof __APP_COMMIT__ !== 'undefined' ? __APP_COMMIT__ : 'unknown',
    buildTime: typeof __APP_BUILD_TIME__ !== 'undefined' ? __APP_BUILD_TIME__ : 'unknown',
};
const cardStyle = {
    border: '1px solid #ddd',
    borderRadius: 10,
    padding: '16px 18px',
    marginBottom: 14,
    fontSize: 14,
    lineHeight: 1.7,
};
const labelStyle = { color: '#888', marginRight: 8 };
const valueStyle = { fontFamily: 'monospace', wordBreak: 'break-all' };
function Row({ label, value }) {
    return (_jsxs("div", { children: [_jsxs("span", { style: labelStyle, children: [label, ":"] }), _jsx("span", { style: valueStyle, children: value })] }));
}
export default function VersionPage() {
    const [backend, setBackend] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let alive = true;
        // /version на бэке; nginx срезает /api/ → клиент дергает /api/version. Anonymous.
        fetch(`${API_URL}/api/version`, { headers: { Accept: 'application/json' } })
            .then((r) => {
            if (!r.ok)
                throw new Error(`HTTP ${r.status}`);
            return r.json();
        })
            .then((data) => {
            if (alive) {
                setBackend(data);
                setLoading(false);
            }
        })
            .catch((e) => {
            if (alive) {
                setError(String(e));
                setLoading(false);
            }
        });
        return () => {
            alive = false;
        };
    }, []);
    return (_jsxs("div", { style: { maxWidth: 560, margin: '0 auto', padding: 24 }, children: [_jsx("h1", { style: { fontSize: 20, marginBottom: 4 }, children: "\u0412\u0435\u0440\u0441\u0438\u044F \u0441\u0431\u043E\u0440\u043A\u0438" }), _jsx("p", { style: { color: '#888', fontSize: 13, marginBottom: 20 }, children: "\u0422\u043E\u0447\u043D\u044B\u0435 \u0432\u0435\u0440\u0441\u0438\u0438 \u0437\u0430\u0434\u0435\u043F\u043B\u043E\u0435\u043D\u043D\u044B\u0445 \u043E\u0431\u0440\u0430\u0437\u043E\u0432. version \u2014 \u0438\u0437 package.json, commit \u2014 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 git SHA, buildTime \u2014 \u043C\u043E\u043C\u0435\u043D\u0442 \u0441\u0431\u043E\u0440\u043A\u0438 \u043E\u0431\u0440\u0430\u0437\u0430." }), _jsx("h2", { style: { fontSize: 15, margin: '0 0 8px' }, children: "Frontend" }), _jsxs("div", { style: cardStyle, children: [_jsx(Row, { label: "version", value: FRONTEND.version }), _jsx(Row, { label: "commit", value: FRONTEND.commit }), _jsx(Row, { label: "buildTime", value: FRONTEND.buildTime })] }), _jsx("h2", { style: { fontSize: 15, margin: '0 0 8px' }, children: "Backend" }), _jsxs("div", { style: cardStyle, children: [loading && _jsx("div", { style: { color: '#888' }, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026" }), error && _jsxs("div", { style: { color: '#c0392b' }, children: ["\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C: ", error] }), backend && (_jsxs(_Fragment, { children: [_jsx(Row, { label: "service", value: backend.service ?? 'unknown' }), _jsx(Row, { label: "version", value: backend.version ?? 'unknown' }), _jsx(Row, { label: "commit", value: backend.commit ?? 'unknown' }), _jsx(Row, { label: "buildTime", value: backend.buildTime ?? 'unknown' })] }))] }), _jsx("a", { href: "/app", style: { fontSize: 14 }, children: "\u2190 \u0412 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435" })] }));
}
